<template>
  <div class='mt-1'>
    <b-modal
      ref='unlinkProductModal'
      id='unlinkProductModal'
      hide-footer
      hide-header
      header-bg-variant='info'
      header-text-variant='light'
      size='lg'
      @show='showModal()'
      :no-close-on-esc='loading'
      :no-close-on-backdrop='loading'
    >
      <b-overlay
        :show='lookingTermsOfUse'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-100'
        style='min-height: 150px'
      >
        <section class='modal-font-family'>
          <section class='d-flex justify-content-between w-100 mb-1'>
            <section v-if="role && role.name">
              <span class="header-title">Desvincular produto do cargo {{ role.name }}</span>
            </section>
            <b-icon
              @click='closeModal()'
              class='cursor-pointer ml-2'
              font-scale='2.2'
              icon='x'
              color='#022245'
            >
            </b-icon>
          </section>

          <section v-if="product && product.name && role && role.name" class="content d-flex align-items-center p-2">
            <section>
              <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C11 5.71667 10.904 5.479 10.712 5.287C10.52 5.095 10.2827 4.99933 10 5C9.71667 5 9.479 5.096 9.287 5.288C9.095 5.48 8.99933 5.71733 9 6C9 6.28333 9.096 6.521 9.288 6.713C9.48 6.905 9.71733 7.00067 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20Z"
                  fill="#022245" />
              </svg>
            </section>
            <section class="ml-3">
              <p class="mb-1">Desvincular o produto <strong>{{ product.name }}</strong> do cargo
                <strong>{{ role.name }}</strong></p>
              <p>Essa ação não poderá ser desfeita. Deseja realmente desvincular o produto do cargo?</p>
            </section>
          </section>


          <section class='d-flex justify-content-between mt-4'>
            <base-button
              class='w-50 mr-3 btn-cancel'
              @click='closeModal()'
            >
              <span>Cancelar</span>
            </base-button>

            <b-overlay
              :show='loading'
              rounded
              opacity='0.6'
              spinner-small
              spinner-variant='primary'
              class='d-inline-block w-50'
            >
              <base-button
                class='w-100 btn-add d-flex align-items-center justify-content-center'
                @click='unlink()'
              >
                <span class='mr-2'> Desvincular </span>
              </base-button>
            </b-overlay>
          </section>
        </section>

        <template v-slot:overlay>
          <div class='text-center loading-spinner'>
            <b-spinner
              style='width: 2rem; height: 2rem'
              variant='primary'
              label='Large Spinner'
            ></b-spinner>
            <h6 class='text-primary'>Buscando codições de uso...</h6>
          </div>
        </template>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'UnlinkProductModal',
  components: {},
  props: {
    product: {
      type: Object,
      required: false,
      default: Object
    },
    role: {
      type: Object,
      required: false,
      default: Object
    }
  },
  data() {
    return {
      loading: false,
      lookingTermsOfUse: false,
      termsOfUse: {
        temperature: null
      }
    }
  },
  async mounted() {
    try {

    } catch (e) {
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    }
  },
  methods: {
    ...mapActions('productLegalConsultation', {
      handleUnlinkProduct: 'handleUnlinkProduct'
    }),
    async showModal() {
      try {

      } catch (e) {

      }
    },

    async unlink() {
      try {
        this.loading = true
        const { data, status } = await this.handleUnlinkProduct(
          {
            productsIds: [this.product._id],
          }
        )
        this.loading = false
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast('Produto desvinculado com sucesso!', {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.closeModal()
        this.$emit('update')
      } catch (e) {
        this.$bvToast.toast('Não foi possível desvincular o produto do cargo, verifique os dados e tente novamente.', {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 10000
        })
        this.loading = false
        this.closeModal()
        this.$emit('update')
      }
    },

    closeModal() {
      if (this.loading) {
        return
      }
      this.$bvModal.hide('unlinkProductModal')
    }
  },
  created() {
  }
}
</script>
<style lang='scss' scoped>
.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.header-title {
  font-weight: 700;
  font-size: 20px;
  color: #262626;
}

.content {
  background: #04A8F366;
  border-radius: 8px;
  border: 1px solid #04A8F3;

  p {
    font-weight: 400;
    color: #022245;
  }
}
</style>
